export default __webpack_public_path__ + "static/media/FigmaPersonalWebsite.13b389fb.webp";